import React from "react";
import { useNavigate } from "react-router-dom";
import ROUTES from "../utils/routesConstants";
import { getInfo } from "../utils/types";
import { useTranslation } from "react-i18next";

const PaymentFailed = () => {
  const { t } = useTranslation();
  const InfoParse = getInfo();
  const navigate = useNavigate();

  const gotoHome = () => {
    if (InfoParse && InfoParse.roles && Array.isArray(InfoParse.roles)) {
      if (InfoParse.roles.some((s) => s === "GLOBAL_ADMIN")) {
        navigate(ROUTES.GLOBAL_ADMIN);
      } else if (InfoParse.roles.some((s) => s === "SUPER_ADMIN")) {
        navigate(ROUTES.PARTNER);
      } else {
        navigate(ROUTES.TENANT);
      }
    } else {
      navigate(ROUTES.LOGIN);
    }
  };

  return (
    <section className="bg-white flex items-center h-screen">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center">
              <svg
                className="w-12 h-12 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
          </div>
          <h1 className="mb-4 text-5xl tracking-tight font-extrabold text-red-500">
            {t("Payment Failed!")}
          </h1>
          <p className="mb-4 text-2xl tracking-tight font-medium text-black md:text-3xl">
            {t("Your payment could not be processed.")}
          </p>
          <p className="mb-6 text-lg font-light text-gray-500">
            {t(
              "Unfortunately, your transaction was unsuccessful or was cancelled. Please try again or contact support if the issue persists."
            )}
          </p>
          <button
            className="inline-flex text-white bg-theme hover:bg-theme focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded text-sm px-5 py-2.5 text-center my-4"
            onClick={gotoHome}
          >
            {t("Back to Homepage")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default PaymentFailed;
